import * as React from 'react'
import "./DefLink.scss"

export default function DefLink (props) {
    return (
      <span className="def-link-container">
        ◌<span className="def-link" onClick={() => props.clickHandler(props.defLinkText)}>{props.defLinkText}</span>
      </span>
    )
}